"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomInteger = function () { return Number(Math.round(Math.random() * 10)); };
exports.randomNumber = function () { return Number((Math.random() * 1000).toPrecision(2)); };
exports.randomPercent = function () { return Number((Math.random() * 10).toPrecision(4)); };
